<mf-auto-complete
  [label]="label"
  [endpointSuggest]="endpointSuggest"
  [ngModel]="value?.displayText ?? ''"
  [selectedId]="value?.id"
  [filters]="filters"
  [orderBy]="orderBy"
  [wrappedNgControl]="ngControl"
  [showAddButton]="!hideAddButton"
  (selectedItemChange)="selectedItemChange($event)"
  (createNewClick)="createNewClick()" />
